module.exports = __webpack_public_path__ + "media/src/pages/GuidedOnboarding/images/fileGreenCheckGears-79d4d8f0b1f8fdeafdf9ffa2ac182039.png";